import { render, staticRenderFns } from "./PerformanceReviewOptionsDialog.vue?vue&type=template&id=5b1bb676&"
import script from "./PerformanceReviewOptionsDialog.vue?vue&type=script&lang=js&"
export * from "./PerformanceReviewOptionsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports